export default {
      id: "graph-lanaudiere-usage",
      viewBox: "0 0 156 118",
      url: __webpack_public_path__ + "svg/sprite.svg#graph-lanaudiere",
      toString: function () {
        return this.url;
      }
    }